import { ConsumptionChartBy } from "types";

export enum ChartSource {
    MULTIPLE_SENSORS = "MULTIPLE_SENSORS",
    SINGLE_SENSOR = "SINGLE_SENSOR",
    SINGLE_ACTUATOR = "SINGLE_ACTUATOR",
    MULTIPLE_ACTUATORS = "MULTIPLE_ACTUATORS",
    SENSORS_AND_ACTUATORS = "SENSORS_AND_ACTUATORS",
    SINGLE_GATEWAY = "SINGLE_GATEWAY",
    MULTIPLE_GATEWAYS = "MULTIPLE_GATEWAYS",
    STORAGE = "STORAGE",
    EVENT = "EVENT",
    NOTIFIER = "NOTIFIER",
    NETWORK = "NETWORK",
    AGGREGATED_MULTIPLE_SENSORS = "AGGREGATED_MULTIPLE_SENSORS",
    SINGLE_LDSU = "SINGLE_LDSU",
    SUBSCRIPTION = "SUBSCRIPTION",
}

export enum ChartType {
    SINGLE_LINE = "SINGLE_LINE",
    MULTIPLE_LINES = "MULTIPLE_LINES",
    HEATMAP = "HEATMAP",
    BAR = "BAR",
    STACKED_BAR = "STACKED_BAR",
    DONUT = "DONUT",
    PIE = "PIE",
    CARD_NUMBER_ONLY = "CARD_NUMBER_ONLY",
    CARD_BAR = "CARD_BAR",
    CARD_MULTIPLE_LINES = "CARD_MULTIPLE_LINES",
    CARD_MULTIPLE_LINES_TYPE2 = "CARD_MULTIPLE_LINES_TYPE2",
    CARD_MULTIPLE_LINES_TYPE3 = "CARD_MULTIPLE_LINES_TYPE3",
    CARD_TEXT = "CARD_TEXT",
    GAUGE = "GAUGE",
    GAUGE_COLOURS = "GAUGE_COLOURS",
    CARD_GATEWAY = "CARD_GATEWAY",
    CARD_STATUS = "CARD_STATUS",
    CARD_MULTIPLE_BARS = "CARD_MULTIPLE_BARS",
    TABLE = "TABLE",
    MAPS = "MAPS",
    STATUS = "STATUS",
    USAGE = "USAGE",
    TIMELINE = "TIMELINE",
    SINGLE_STEP_LINE = "SINGLE_STEP_LINE",
    CARD_UPTIME_HISTORY = "CARD_UPTIME_HISTORY",
}

// This is based on the chart design
export const MAX_CHART_VALUE_CHARS = 8;

export const CONSUMPTION_CHART_SHIFT_TIME = 10 * 60;


export const ConsumptionAverageText = {
    [ConsumptionChartBy.Day]: "Hourly",
    [ConsumptionChartBy.Week]: "Daily",
    [ConsumptionChartBy.Month]: "Daily",
    [ConsumptionChartBy.Year]: "Monthly",
};
